import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the page to top on route change.
 * Place inside a Router context (e.g. inside Layout components).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
